// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".speed-dial{position:fixed;bottom:5px;right:5px;z-index:2}.btn--floating{position:relative}.btn--floating.btn--small{width:30px;height:30px}.speed-dial__list{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}@media screen and (max-width:959px){.speed-dial__list{padding-right:20px}.speed-dial--bottom:not(.speed-dial--absolute){bottom:auto;right:0;top:60px}}", ""]);
// Exports
module.exports = exports;
